module.exports = __webpack_public_path__ + "static/img/2389_phase_function_Paper_Points.5985fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2389_phase_function_Paper_Points.png
// module id = r3mq
// module chunks = 0